import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import ShipmentList from '../components/Shipments/ShipmentList';
import EditShipment from '../components/Shipments/EditShipment';
import ViewShipment from '../components/Shipments/ViewShipment';


const Shipments = () => {
  return (
    <Routes>
      <Route path="/" element={<ShipmentList />} />
      <Route path="/edit/:id" element={<EditShipment />} />
      <Route path="/edit" element={<EditShipment />} />
      <Route path="/view/:id" element={<ViewShipment />} />
    </Routes>
  )
}

export default Shipments;